import './Loader.scss'

const Loader = () => {
    return (
        <div className='loader'>
            <div className="loader__wrapper">
                <p className="loader__text">Loading...</p>
            </div>
        </div>
    );
};

export default Loader;